import React, { PropsWithChildren } from 'react';

import { cnLevel, ILevelProps } from './index';

function Level({
    key,
    className,
    children
}: PropsWithChildren<ILevelProps>) {

    return (
        <div key={key} className={cnLevel({}, [className])}>
            {children}
        </div>
    );
}

export default Level;
